import "./hsg";
import "./initial-consult";
import "./follow-up-consult";
import "./genetic-counseling";
import "./trigger-shot";
import "./iui";
import "./mini-ivf";
import "./mock-transfer";
import "./endometrial-biopsy";
import "./sperm-freeze";
import "./ovarian-stimulation";
import "./egg-retrieval";
import "./embryo-transfer";
import "./frozen-embryo-transfer";
import "./endometrial-preparation";
import "./luteal-support";
import "./two-week-wait";
import "./fertilization-icsi";
import "./embryo-culture";
import "./embryo-biopsy-pgt";
import "./cryopreservation";
import "./sperm-collection";
import "./hysteroscopy";
import "./laparoscopy";
import "./tese";
import "./assisted-hatching";
import "./myomectomy";
import "./polypectomy";
import "./endometrial-scratch";
import "./hormonal-testing";
import "./std-testing";
import "./thyroid-testing";
import "./urinalysis";
import "./transabdominal-ultrasound";
import "./transvaginal-ultrasound";
import "./doppler-ultrasound";
import "./hysterosonography";
import "./antral-follicle-count";
import "./pelvic-mri";
import "./karyotyping";
import "./carrier-testing";
import "./exome-genome-sequencing";
import "./swab-test";
import "./pap-smear";
import "./surgical-sperm-retrieval";
import "./testicular-biopsy";
